import { useEffect, useState } from 'react';
import MapWrapper from './MapWrapper';
import { useParams } from 'react-router-dom';
import { getSampleMap, updateSampleMap } from '../../actions/sampleMaps';
import axios from 'axios';

const SampleMap = ({ stage }) => {
  const { sampleMapId } = useParams();
  const API_ENDPOINT =
  process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_API_ENDPOINT_PROD
    : process.env.REACT_APP_API_ENDPOINT_DEV

  useEffect(() => {
    (async () => {
      const res = await (await getSampleMap(sampleMapId)).json();
      const activeOrders = await axios.get(API_ENDPOINT + '/order/active');
      const orderInfo = activeOrders.data.find(order => order.sampleMap === sampleMapId)
      if (orderInfo) {
        setOrderID(orderInfo.orderCode);
      }

      setPrimers(res.primers);
      setSamples(res.samples);
      if (res.cartridge) {
        setCartridge(res.cartridge._id);
        setCartridgeData(res.cartridge);
      }
      setOrders(res.orders);
      const map = {};
      map['blue'] = undefined;
      map['green'] = undefined;
      map['yellow'] = undefined;
      map['orange'] = undefined;
      let i = 0;
      for (const key in map) {
        if (i >= res.primers.length) {
          break;
        }
        map[key] = res.primers[i]._id;
        i += 1;
      }
      setColorMap(map);
    })()
  }, []);

  const [primers, setPrimers] = useState([]);
  const [samples, setSamples] = useState([]);
  const [colorMap, setColorMap] = useState({});
  const [cartridge, setCartridge] = useState("None");
  const [cartridgeData, setCartridgeData] = useState({});
  const [orders, setOrders] = useState([]);
  const [orderID, setOrderID] = useState('');

  return (
    <>
      <h1>{orderID}</h1>
      <MapWrapper
        sampleMapId={sampleMapId}
        stage={stage}
        samples={samples}
        primers={primers}
        setSamples={setSamples}
        setPrimers={setPrimers}
        colorMap={colorMap}
        setColorMap={setColorMap}
        cartridge={cartridge}
        setCartridge={setCartridge}
        cartridgeData={cartridgeData}
        setCartridgeData={setCartridgeData}
        orders={orders}
      />
    </>
  );
};

export default SampleMap;
